'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactInfiniteScroller = require('react-infinite-scroller');var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _CompanyCard = require('../../components/\u0421ompany\u0421ard/CompanyCard');var _CompanyCard2 = _interopRequireDefault(_CompanyCard);
var _constants = require('../../constants');





var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _modifyImageLink = require('../../utils/modifyImageLink');var _modifyImageLink2 = _interopRequireDefault(_modifyImageLink);
var _ProfessionalsList = require('./ProfessionalsList.scss');var _ProfessionalsList2 = _interopRequireDefault(_ProfessionalsList);

var _realtors_association_logo = require('../../../static/images/realtors_association_logo.png');var _realtors_association_logo2 = _interopRequireDefault(_realtors_association_logo);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
var brokerDescriptionHe = 'רשת ברוקר הינה קהילת הנדל"ן האיכותית ביותר בישראל, הרשת מונה כיום למעלה מ - 100 נקודות שירות ובכל נקודה בארץ.';
var realtorsAssociationDescriptionHe = {
  he: 'החברות בלשכת מתווכי הנדל“ן הארצית מעמידה אתכם בשורה הראשונה והאיכותית של מתווכי הנדל“ן בישראל. הלשכה פועלת באופן נמרץ להעלות את תדמיתו של המתווך החבר בלשכה ״כמתווך מקצוען בעל ידע רב והמחוייב לכללי האתיקה של הארגון״. הלשכה מעצימה ומבדלת את חבריה במגוון מדיות לציבור הרחב.',
  en: 'The companies in the National Real Estate Brokers Association place you at the forefront of high-quality real estate brokers in Israel. The office works diligently to enhance the reputation of its affiliated broker as “a professional broker with extensive knowledge and commitment to the organization’s ethical principles.” The office empowers and distinguishes its members through various media channels for the general public.',
  ru: 'Компании в Национальной ассоциации риэлторов представляют вас в первом и качественном ряду недвижимостных риэлторов в Израиле. Ассоциации риэлторов работает усердно, чтобы повысить репутацию своих аффилированных риэлторов как “профессионалов с обширными знаниями и приверженностью этическим принципам организации“. Ассоциации риэлторов укрепляет и выделяет своих членов через различные медиа-каналы для широкой публики.',
  fr: 'Les entreprises de l’Association nationale des courtiers immobiliers vous placent en première ligne et de qualité parmi les courtiers immobiliers en Israël. Le bureau travaille avec diligence pour améliorer la réputation du courtier affilié en tant que “courtier professionnel avec une connaissance approfondie et engagé envers les principes éthiques de l’organisation”. Le bureau renforce et distingue ses membres à travers divers médias pour le grand public.' };var


ProfessionalsList = function (_Component) {_inherits(ProfessionalsList, _Component);function ProfessionalsList() {var _temp, _this, _ret;_classCallCheck(this, ProfessionalsList);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    renderList = function () {var _this$props =
      _this.props,locale = _this$props.locale,translate = _this$props.translate;

      return _this.props.professionals && _this.props.professionals.map(function (item, idx) {
        var nameInCurrentLocale = (0, _get2.default)(item, 'name[' + locale + ']');
        var descriptionInCurrentLocale = (0, _get2.default)(item, 'description[' + locale + ']');
        var titleInCurrentLocale = (0, _get2.default)(item, 'title[' + locale + ']');

        var name = nameInCurrentLocale || (0, _get2.default)(item, 'name[' + _constants.language.default + ']');
        var description = descriptionInCurrentLocale || (0, _get2.default)(item, 'description[' + _constants.language.default + ']');
        var title = titleInCurrentLocale || (0, _get2.default)(item, 'title[' + _constants.language.default + ']');

        return (
          _react2.default.createElement(_CompanyCard2.default, {
            link: (0, _appendLocale2.default)(_this.props.locale, '/company/' + item.id),
            translate: translate,
            id: item.id,
            key: item.id,
            logo: (0, _modifyImageLink2.default)(item.image, _constants.imageModifierTypes.LOGO),
            name: name,
            title: title,
            description: description,
            count: item.properties_count,
            nameInCurrentLocale: !nameInCurrentLocale,
            descriptionAtDefaultLang: !descriptionInCurrentLocale
            // clickHandler={() => this.handleClick(item.id)}
            , withoutCount: item.type !== _constants.PROFESSIONALS_TYPES.AGENCY,
            isLink: true }));


      });
    }, _this.

    renderCards = function () {var _cx;var _this$props2 =
      _this.props,translate = _this$props2.translate,isProfessionals = _this$props2.isProfessionals,isBroker = _this$props2.isBroker,companyNameForFilter = _this$props2.companyNameForFilter,currentCompanyType = _this$props2.currentCompanyType;
      var brokerCommunityTitle = translate('title', 'brokerCommunity').toString();
      var realtorsAssociationTitle = translate('title', 'realtorsAssociation').toString();

      return (
        _react2.default.createElement('div', { className: (0, _classnames2.default)(_ProfessionalsList2.default.professionalsList, (_cx = {}, _cx[_ProfessionalsList2.default.brokerList] = isBroker, _cx)) },

          isProfessionals &&
          currentCompanyType === _constants.PROFESSIONALS_TYPES.AGENCY && (
          !companyNameForFilter || brokerCommunityTitle.match(RegExp(companyNameForFilter, 'i'))) &&
          _react2.default.createElement(_CompanyCard2.default, {
            link: (0, _appendLocale2.default)(_this.props.locale, '/professionals/broker'),
            translate: translate,
            id: 'brokerCommunityLink',
            key: 'brokerCommunityLink',
            logo: _constants.brokerCommunityLogo,
            title: brokerCommunityTitle,
            name: brokerCommunityTitle,
            description: brokerDescriptionHe,
            descriptionAtDefaultLang: true,
            withoutCount: true,
            isBroker: true }),



          isProfessionals &&
          currentCompanyType === _constants.PROFESSIONALS_TYPES.AGENCY && (
          !companyNameForFilter || brokerCommunityTitle.match(RegExp(companyNameForFilter, 'i'))) &&
          _react2.default.createElement(_CompanyCard2.default, {
            link: (0, _appendLocale2.default)(_this.props.locale, '/professionals/realtors_association'),
            translate: translate,
            id: 'realtorsAssociationLink',
            key: 'realtorsAssociationLink',
            logo: _realtors_association_logo2.default,
            name: realtorsAssociationTitle,
            description: realtorsAssociationDescriptionHe[_this.props.locale],
            descriptionAtDefaultLang: true,
            withoutCount: true,
            isRealtorsAssociation: true }),


          _this.renderList()));


    }, _temp), _possibleConstructorReturn(_this, _ret);}ProfessionalsList.prototype.

  render = function render() {var
    isProfessionals = this.props.isProfessionals;

    return (
      isProfessionals ?
      _react2.default.createElement(_reactInfiniteScroller2.default, {
          className: _ProfessionalsList2.default.cardsWrapper,
          loadMore: this.props.loadMore,
          threshold: 500,
          hasMore: this.props.hasMore,
          loader: _react2.default.createElement('div', { className: 'loader', key: 0 }, 'Loading ...') },

        this.renderCards()) :

      this.renderCards());

  };return ProfessionalsList;}(_react.Component);exports.default = ProfessionalsList;


ProfessionalsList.propTypes = {
  isMobile: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  companyNameForFilter: _propTypes2.default.string,
  professionals: _propTypes2.default.array,
  isProfessionals: _propTypes2.default.bool,
  isBroker: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  loadMore: _propTypes2.default.func,
  hasMore: _propTypes2.default.bool,
  currentCompanyType: _propTypes2.default.string };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProfessionalsList/ProfessionalsList.js
// module id = 2762
// module chunks = 0